export default __webpack_public_path__ + "static/media/07.36627eff.svg";